// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"a686dfa1","707":"381f8b96","729":"afe2fe1f"}[chunkId] + ".js";
};